import { useTranslations } from "next-intl";
import AddDietBig from "@/assets/icons/add-diet-big.svg";
import AddDietSmall from "@/assets/icons/add-diet-small.svg";
import { buttonVariants } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { sendEvent } from "@/features/analytics/gtm/event";
import { getLocaleForPathname, Link } from "@/i18n/navigation";
import { cn } from "@/lib/utils";
import { useCartStore } from "../cart-provider";

export const BuyMoreCta = () => {
  const t = useTranslations();
  const cartStore = useCartStore((state) => state);
  const locale = getLocaleForPathname();

  const dietCount = cartStore.items.length;
  if (dietCount === 0) return null;

  const Icon = dietCount === 1 ? AddDietBig : AddDietSmall;

  return (
    <Card className="shadow-none transition-colors duration-100 hover:bg-brand-grey1">
      <CardContent className="grid place-items-center p-4 sm:p-6">
        <div className="flex items-center">
          <Icon className="hidden h-16 w-16 sm:block sm:h-24 sm:w-24 md:h-auto md:w-auto" />
          <Link
            className={cn(
              buttonVariants({ variant: "link" }),
              "no-underline max-sm:m-0 max-sm:min-h-0 max-sm:p-0 sm:ml-2",
            )}
            href={{ pathname: "/diets/[[...slug]]", params: { slug: [] } }}
            locale={locale}
            onClick={() =>
              sendEvent({
                event: "DIET_ADD",
              })
            }
          >
            {t("checkout.addAnother")}
          </Link>
        </div>
      </CardContent>
    </Card>
  );
};
